import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LinePlaneFlyIcon from 'components/Luxkit/Icons/line/LinePlaneFlyIcon'
import CaptionTextBlock from 'components/Luxkit/TextBlocks/CaptionTextBlock'
import Group from 'components/utils/Group'
import React, { PropsWithChildren, ReactNode } from 'react'

interface Props {
  callToAction: ReactNode
  title: 'Hotel' | 'Hotel + flights' | undefined
  'data-testid'?: string
}

function AccommodationPackageTilePricingBlock(props: PropsWithChildren<Props>) {
  const {
    callToAction,
    children,
    title,
    'data-testid': dataTestId,
  } = props

  return <Group
    direction="vertical"
    verticalAlign="space-between"
    gap={20}
    data-testid={dataTestId}
  >
    <VerticalSpacer gap={8}>
      {title && <CaptionTextBlock
        variant="large"
        weight="bold"
        startIcon={title === 'Hotel + flights' && <LinePlaneFlyIcon />}
      >
        {title}
      </CaptionTextBlock>}
      {children && <div>{children}</div>}
    </VerticalSpacer>

    {callToAction && <Group direction="vertical" gap={8}>
      {callToAction}
    </Group>}
  </Group>
}

export default AccommodationPackageTilePricingBlock
